<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      我的资料
    </div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="100px"
             class="form">
      <div class="row topImg">
        <el-form-item label="机构logo："
                      class="topImgBox"
                      prop="name">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="2"
                     :orgid="orgid"
                     :onSuccess="handleSuccess">
            <div class="logobox">
              <img :src="ruleForm.logoImg"
                   v-show="ruleForm.logoImg"
                   alt="">
            </div>
          </webupload>
          <span class="topImgSpan">注：建议png格式，200px*60px</span>
        </el-form-item>
        <el-form-item label="封面图："
                      class="topImgBox">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="2"
                     :orgid="orgid"
                     class="addt4box"
                     :onSuccess="handleSuccess2">
            <div class="addmp4box"
                 v-show="!bansrc">
              <img src="../../assets/img/icon/import.png"
                   alt="">
              <span>上传图片</span>
            </div>
            <div class="logobox"
                 v-show="bansrc">
              <img :src="bansrc"
                   alt="">
            </div>
          </webupload>
          <span class="topImgSpan">注：建议png格式，496px*280px</span>
        </el-form-item>
        <el-form-item label="banner图："
                      class="topImgBox"
                      prop="name">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="2"
                     :orgid="orgid"
                     :onSuccess="handleSuccess3">
            <div class="addmp4box"
                 v-show="!ruleForm.homebanUrl">
              <img src="../../assets/img/icon/import.png"
                   style="width:12px;height:12px"
                   alt="">
              <span>上传图片</span>
            </div>
            <div class="logobox"
                 v-show="ruleForm.homebanUrl">
              <img :src="ruleForm.homebanUrl"
                   alt="">
            </div>
          </webupload>
          <span class="topImgSpan">注：建议png格式，1920px*300px</span>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="机构名称：">
          <el-input v-model="ruleForm.name"
                    disabled
                    style="width:333px"
                    placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="机构类型："
                      prop="type">
          <el-select v-model="ruleForm.type"
                     style="width:333px"
                     placeholder="请选择机构类型">
            <el-option v-for="item in OrgTypeOptions"
                       :key="item.id"
                       :label="item.valueText"
                       :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="地域："
                      prop="region">
          <el-cascader v-model="ruleForm.region"
                       style="width:333px"
                       placeholder="请选择省市区县"
                       :options="arealist"
                       @expand-change="expandChange"></el-cascader>
          <span class="regionspan"
                v-show="isRegion"
                @click.stop>{{region}}</span>
        </el-form-item>
        <el-form-item label="入驻店铺授权书："
                      prop="name"
                      style="height:53px"
                      label-width="138px">
          <div class="shouquanshu">
            <img src="../../assets/img/icon/bianji2.png"
                 alt="">
            <span>{{pdfname}}</span>
          </div>
        </el-form-item>
      </div>

      <div class="row">
        <el-form-item label="机构简介：">
          <el-input v-model="ruleForm.Orgprofile"
                    style="width:873px"
                    placeholder="请输入机构简介（仅微信分享时使用，非必填）"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="addtop5">
      <div @click="ToSub">
        <span>保存</span>
      </div>
    </div>
  </div>
</template>

<script>
import webupload from '../../components/webupload/webupload.vue';
import { areaList } from '@vant/area-data';
export default {
  name: 'usInfor',
  components: {
    webupload
  },
  data () {
    return {
      storeName: '',
      orgid: 0,
      arealist: [],
      region: '',
      ruleForm: {
        name: '',
        region: '',
        type: '',
        logoImg: '',
        banid: '',
        logoId: '',
        pdfId: '',
        homebanUrl: '',
        homebanId: 0,
        Orgprofile: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择机构类型', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择地域信息', trigger: 'change' }
        ],
      },
      OrgTypeOptions: [],
      bansrc: '',
      pdfname: '',
      isRegion: true
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'));
    this.GetOrgTypeList()
    this.getarealist();
    this.GetMyStoreList()
  },
  methods: {
    GetMyStoreList () {
      this.httphelper.get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
        id: this.orgid,
      })
        .then(res => {
          if (res.code == 200) {
            this.ruleForm.name = res.data.org_name
            this.ruleForm.Orgprofile = res.data.orgprofile
            this.ruleForm.type = res.data.org_type
            this.ruleForm.logoImg = res.data.logo_url
            this.ruleForm.region = [res.data.provinceCode, res.data.cityCode, res.data.districtCode]
            this.ruleForm.logoId = res.data.logo_rid
            this.ruleForm.banid = res.data.banner_rid
            this.ruleForm.homebanUrl = res.data.homeBanner_url
            this.ruleForm.homebanId = res.data.homeBanner_rid
            this.bansrc = res.data.banner_url
            this.pdfname = res.data.res_Title
            for (let a in areaList.province_list) {
              if (a == res.data.provinceCode) {
                this.region = areaList.province_list[a]
              }
            }
            for (let a in areaList.city_list) {
              if (a == res.data.cityCode) {
                this.region = this.region + ' / ' + areaList.city_list[a]
              }
            }
            for (let a in areaList.county_list) {
              if (a == res.data.districtCode) {
                this.region = this.region + ' / ' + areaList.county_list[a]
              }
            }
          }
        });
    },
    GetOrgTypeList () {
      this.httphelper
        .get('/api/BasicsmesApi/GetCodeResultList', {
          type: 5
        })
        .then(res => {
          if (res.code == 200) this.OrgTypeOptions = res.data
        });
    },
    getarealist () {
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
      }
    },
    expandChange (val) {
      this.isRegion = false
      if (val.length == 1) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            this.arealist[i].children = [];
          }
        }
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == val[0].substr(0, 2)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                this.arealist[i].children.push({
                  value: b,
                  label: areaList.city_list[b],
                  children: []
                });
              }
            }
          }
        }
      } else if (val.length == 2) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            for (let a = 0; a < this.arealist[i].children.length; a++) {
              if (this.arealist[i].children[a].value == val[1]) {
                this.arealist[i].children[a].children = [];
              }
            }
          }
        }
        for (let b in areaList.county_list) {
          if (b.substr(0, 4) == val[1].substr(0, 4)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                for (let a = 0; a < this.arealist[i].children.length; a++) {
                  this.arealist[i].children[a].children.push({
                    value: b,
                    label: areaList.county_list[b]
                  });
                }
              }
            }
          }
        }
      }
    },
    handleSuccess (response) {
      this.ruleForm.logoId = response.resid;
      this.ruleForm.logoImg = response.ossfileurl;
    },
    handleSuccess2 (response) {
      this.ruleForm.banid = response.resid;
      this.bansrc = response.ossfileurl;
    },
    handleSuccess3 (response) {
      this.ruleForm.homebanId = response.resid;
      this.ruleForm.homebanUrl = response.ossfileurl;
    },
    ToSub () {
      if (this.ruleForm.Orgprofile == null) {
        this.ruleForm.Orgprofile = ''
      }
      if (this.ruleForm.Orgprofile.length > 49) {
        return this.$message({
          message: '简介最多50个字',
          type: 'warning'
        });
      }
      this.httphelper
        .post('/api/CGPEnterPriseApi/UpdOrgInfo', {
          logorid: Number(this.ruleForm.logoId),
          type: Number(this.ruleForm.type),
          provinceCode: this.ruleForm.region[0],
          Orgprofile: this.ruleForm.Orgprofile,
          cityCode: this.ruleForm.region[1],
          districtCode: this.ruleForm.region[2],
          orgId: this.orgid,
          homeBannerId: Number(this.ruleForm.homebanId),
          bannId: Number(this.ruleForm.banid)
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }
        });
    },
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 70px;
}
.shouquanshu {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    width: 333px;
    border-bottom: 1px solid #e5e5e5;
    height: 40px;
    display: flex;
    align-items: center;
}
.shouquanshu img {
    margin-right: 10px;
    margin-left: 10px;
}
.shouquanshu span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.addtop5 {
    margin-top: 63px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.addtop5 div {
    width: 165px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    margin: 0 5px;
    color: #ffffff;
    cursor: pointer;
}
.addmp4box {
    width: 120px;
    height: 40px;
    border: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
}
.addmp4box span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.logobox {
    height: 40px;
    border: 1px solid #eee;
    position: relative;
}
.logobox img {
    height: 40px;
    max-width: 180px;
}
.regionspan {
    color: #606266;
    font-size: inherit;
    background-color: #fff;
    position: absolute;
    height: 36px;
    line-height: 36px;
    left: 15px;
    top: 2px;
}
.banimg {
    width: 96px;
    height: 54px;
}
.addt4box ::v-deep .el-upload--text {
    height: 54px;
}
.addt4box {
    height: 54px;
}
.topImg {
    margin-bottom: 22px;
}
.topImgBox {
    height: 70px;
    width: 320px;
    position: relative;
}
.topImgSpan {
    width: 220px;
    position: absolute;
    top: 36px;
    left: 0px;
    font-size: 12px;
    color: #999999;
}
</style>